import { createContext, useContext } from 'react';

import type { UserProfile } from '../types/userProfile';

export type UserContextType = {
  error?: Error | null;
  loading: boolean;
  userProfile: UserProfile | null;
  getUserProfile: () => Promise<void>;
};

export const UserProfileContext = createContext<UserContextType | null>(null);

export function useUserProfile() {
  const context = useContext(UserProfileContext);
  if (context === null) {
    throw new Error('useUserProfile must be used within a UserProfileProvider');
  }
  return context.userProfile;
}
